import { render, staticRenderFns } from "./XWeek.vue?vue&type=template&id=64356835&scoped=true"
import script from "./XWeek.vue?vue&type=script&lang=ts"
export * from "./XWeek.vue?vue&type=script&lang=ts"
import style0 from "./XWeek.vue?vue&type=style&index=0&id=64356835&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64356835",
  null
  
)

export default component.exports